import { VulnSeverityMapping, vulnSeverityMappingToString } from '../../../../../shared/vulns/severity';
import { CheckboxFilterGroup, FilterPanel } from '../../../generic/Filter';
import type { SelectedOptionsProps } from '../../../generic/Filter';

const FILTER_OPTIONS: Array<{ key: string, label: string }> = [
  { key: vulnSeverityMappingToString(VulnSeverityMapping.CRITICAL), label: 'Critical (9-10)' },
  { key: vulnSeverityMappingToString(VulnSeverityMapping.HIGH), label: 'High (7-8.9)' },
  { key: vulnSeverityMappingToString(VulnSeverityMapping.MEDIUM), label: 'Medium (4-6.9)' },
  { key: vulnSeverityMappingToString(VulnSeverityMapping.LOW), label: 'Low (0.1-3.9)' },
  { key: vulnSeverityMappingToString(VulnSeverityMapping.UNKNOWN), label: 'Unknown' },
];

const SeverityFilter = ({ selectedOptions, onSelect }: SelectedOptionsProps) => (
  <FilterPanel>
    <CheckboxFilterGroup
      title="Severity"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-vuln-severity"
  />
  </FilterPanel>
);

export default SeverityFilter;
